<template>
  <section>
    <SoSelect
      ref="solar-panel-type-select"
      v-model="panelConfig.panel"
      :items="solarPanelOptions"
      placeholder="Select panel type"
      type="simple"
      class="usage-estimate__select"
    />
    <SoSlider
      ref="solar-panel-count-slider"
      v-model="panelConfig.panelCount"
      :label="`Number of panels: ${panelConfig.panelCount}`"
      :min="0"
      :max="30"
    />
  </section>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoSelect from "@/components/formControls/SoSelect.vue"
  import SoSlider from "@/components/SoSlider.vue"
  import { ISolarPanelConfiguration } from "@/services/UsageEstimationService/types"
  import { UsageEstimationService } from "@/services/UsageEstimationService"

  export default defineComponent({
    components: {
      SoSelect,
      SoSlider,
    },
    props: {
      modelValue: {
        type: Object as PropType<ISolarPanelConfiguration>,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      panelConfig: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },

      solarPanelOptions() {
        return UsageEstimationService.getSolarPanelTypes().map((panel) => ({
          value: panel,
          title: panel.name,
        }))
      },
    },
  })
</script>

<style scoped>
  .usage-estimate__select {
    max-width: 300px;
    margin-bottom: 8px;
  }
</style>
